import {useState} from "react";
import {InputType} from "./form/InputType";

export const InputTypeCell = ({initialValue, save, ...rest}) => {

    const [value, setValue] = useState(initialValue);

    const handleBlur = () => {
        if (value !== initialValue) {
            save(value);
        }
    };

    return(
        <InputType value={value} setter={setValue} onBlur={handleBlur} {...rest}/>
    )
}